module["exports"] = [
  "#####",
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/postcode.js
// module id = 959
// module chunks = 1